module.exports = ["Min","Max","Min Tons","Max Tons"]


//////////////////
// WEBPACK FOOTER
// ./src/config/processDimensions.json
// module id = 5424
// module chunks = 1